<script lang="ts" setup>
const emit = defineEmits(["continue", "close"]);
const userStore = useUserStore();
</script>

<template>
  <div>
    <div class="flex gap-2 font-bold flex-wrap">
      <h3 class="text-neutral-200">
        {{ $t("main.modalUserWalletCreate.GFALRecoveryKit") }}
      </h3>
      <h3 class="text-error-300">
        {{ $t("main.modalUserWalletCreate.recoveryKitCaution") }}
      </h3>
    </div>
    <div class="text-neutral-300 flex flex-col gap-4 mt-4">
      <p>
        {{ $t("main.modalUserWalletCreate.recoveryKitInfo") }}
      </p>
      <div
        v-if="userStore.recoveryKitDate"
        class="bg-neutral-500 rounded-xl p-4 text-rarity-exotic flex items-center gap-2">
        <NuxtIcon name="mdi:info" class="w-4 h-4 shrink-0" />
        <p class="text-xs">
          {{ $t("main.modalUserWalletCreate.recoveryKitDate") }}
          <span class="font-bold">
            {{
              new Date(userStore.recoveryKitDate).toLocaleDateString(
                $i18n.locale,
                {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                }
              )
            }}</span
          >
        </p>
      </div>
      <div
        class="bg-neutral-500 rounded-xl p-4 flex items-center justify-between gap-4 cursor-pointer group hover:text-primary-500"
        @click="emit('continue')">
        <NuxtIcon
          name="mdi:shield-key"
          class="w-7 h-7 text-neutral-200 group-hover:text-primary-500" />
        <div class="flex-1 flex flex-col">
          <p class="font-bold text-neutral-200 group-hover:text-primary-500">
            {{ $t("main.modalUserWalletCreate.GFALRecoveryKit") }}
          </p>
          <p class="text-sm group-hover:text-primary-500">
            {{ $t("main.modalUserWalletCreate.generateRecoveryKit") }}
          </p>
        </div>
        <NuxtIcon
          name="mdi:chevron-right"
          class="w-6 h-6 text-neutral-200 group-hover:text-primary-500" />
      </div>
      <BaseButtonSubmit
        :text="$t('main.modalWalletSettings.close')"
        size="lg"
        class="w-full"
        @click="emit('close')" />
    </div>
  </div>
</template>
